<template>
  <div class="domain-content c3">
    <div class="top-nav">
      <div class="top-nav-wrap w1200 auto fix">
        <a class="top-nav-item fl"
           target="_blank"
           :href="item.url"
           v-for="item in navList"
           :key="item.name">
          <div class="item-name f20 mb10">{{item.name}}</div>
          <div class="item-desc f16 lh30 c9">{{item.desc}}</div>
          <div class="item-sub-desc f16 lh30"
               v-html="item.subDesc"></div>
        </a>
      </div>
    </div>
    <div class="tc section-name">企业域名推荐</div>
    <div class="recommend-pro fix w1200 auto">
      <div class="recommend-pro-item fl tc"
           v-for="(item,index) in recommendList"
           :key="index">
        <div v-if="item.isDiscount"
             class="isDiscount">
          <img src
               alt />
        </div>
        <img :src="item.iconPath"
             class
             alt />
        <div class="item-name mt30 f18">{{item.name}}</div>
        <div class="item-price f14 mt10">
          <span class="f18 colorJ">￥</span>
          <span class="f30 colorJ">{{item.price}}</span>
          <span class="f20 colorJ">.{{item.decimal}}</span> /年
        </div>
        <div class="mt60">
          <div class="mt10"
               v-for="sitem in item.desc">
            <div class="fix">
              <div class="fl lh18">
                <img class="mr10 item-icon"
                     src="../../static/assets/allow-transform_03.png"
                     alt />
                <span class="lh18">{{sitem.left}}</span>
              </div>
              <div class="fr lh18">{{sitem.right}}</div>
            </div>
          </div>
        </div>
        <div class="mt40">
          <a class="choose-recommend-btn" href="https://tb.53kf.com/code/client/10168926/3" target="_blank">在线咨询</a>
        </div>
      </div>
    </div>

    <div class="tc section-name">企业域名服务</div>
    <div class="company-domain-server fix w1200 auto">
      <div class="domain-server-item fl mb20"
           :class="{'mr20': index%2 == '0'}"
           v-for="(item,index) in companyDomainList">
        <div class="mt40 ml30">
          <img class="fl mr20"
               :src="item.iconPath"
               alt />
          <div class="fl">
            <div class="f16">{{item.name}}</div>
            <div class="f12 mt10">{{item.desc}}</div>
          </div>
          <a :href="item.path"
             target="_blank"
             class="domain-detail-btn fr mb40 mr20">详情</a>
        </div>
      </div>
    </div>
    <div class="tc section-name">他们都选择了中企动力</div>
    <!-- 友情链接 -->
    <div class="yfriend w1200">
      <section>
        <img src="../../static/assets/friend1.png" />
        <img src="../../static/assets/friend2.png" />
        <img src="../../static/assets/friend3.png" />
        <img src="../../static/assets/friend4.png" />
        <img src="../../static/assets/friend5.png" />
        <img src="../../static/assets/friend6.png" />
        <img src="../../static/assets/friend7.png" />
        <img src="../../static/assets/friend8.png" />
        <img src="../../static/assets/friend9.png" />
        <img src="../../static/assets/friend10.png" />
        <img src="../../static/assets/friend11.png" />
        <img src="../../static/assets/friend12.png" />
      </section>
      <p style="text-align: center;line-height: 1.5;margin-top: 30px;">
        <a href="https://www.300.cn/info/102727.html" target="_blank" rel="noopener noreferrer">中企动力科技股份有限公司（以下简称中企动力）与北京新网数码信息技术有限公司（以下简称新网数码）为同一集团下属公司，双方在业务上有着合作互补的关系。<br />新网数码委托中企动力代理部分域名产品注册服务，详情请点击。</a></p>
    </div>
  </div>
</template>

<script>
import rgfw2 from "../../static/assets/rgfw2.png"
import rgfw1 from "../../static/assets/rgfw1.png"
import rgfw4 from "../../static/assets/rgfw4.png"
import rgfw3 from "../../static/assets/rgfw3.png"
import safetylock from "../../static/assets/safety-lock.png"
import seniordns from "../../static/assets/senior-dns.png"
import dsqiy from "../../static/assets/电商企业.png"
import yuming from "../../static/assets/域名 .png"
import qiyepp from "../../static/assets/企业品牌.png"
export default {
  data () {
    return {
      navList: [
        {
          url: "https://www.300.cn/domain/domain-transform",
          name: "域名转入",
          desc: "轻松转入，享受管家服务",
          subDesc: ''
        },
        {
          url: "https://www.300.cn/domain/trademark",
          name: ".商标",
          desc: "不仅仅是域名",
          subDesc: '<span class="c9">更是互联网知识产权标识</span>'
        },
        {
          url: "https://www.300.cn/domain/info-intro/en/top",
          name: ".top",
          desc: "域名塑造企业品牌",
          subDesc: '<span class="c9">彰显行业地位</span>'
        },
        {
          url: "https://www.300.cn/domain/info-intro/en/group",
          name: ".group",
          desc: "集团、团体的品牌域名",
          subDesc:
            '<span class="f12 colorJ">¥</span><span class="f20 colorJ">30.</span><span class="f12 colorJ">00</span><span class="f12 c9">&nbsp;&nbsp/首年</span>'
        }
      ],
      recommendList: [
        {
          iconPath: yuming,
          isDiscount: true,
          name: "建站必备后缀",
          code: "jzbb",
          price: "366",
          decimal: "00",
          desc: [
            { left: "英文.com", right: "互联网优选顶级域名" },
            { left: "英文.cn", right: "中国企业互联网标识" },
            { left: "英文.net", right: "全球商业品牌的选择" }
          ]
        },

        {
          iconPath: dsqiy,
          name: "电商企业专属",
          code: "dsqy",
          price: "1666",
          decimal: "00",
          desc: [
            { left: "中文.公司", right: "企业在网络的“门牌号”" },
            { left: "中文.网店", right: "企业电商品牌的象征" },
            { left: "中文.网络", right: "互联网标识的顶级域名" }
          ]
        },
        {
          iconPath: qiyepp,
          name: "企业品牌保护",
          code: "qypp",
          price: "3666",
          decimal: "00",
          desc: [
            { left: "中文.普通网址", right: "便于浏览和记忆网址域名" },
            { left: "中文.中国", right: "中国品牌的国家域名" },
            { left: "中文.企业", right: "互联网品牌、实力的彰显" }
          ]
        }
      ],
      companyDomainList: [
        {
          path: "https://www.300.cn/domain/app-detail/domain0006",
          iconPath: rgfw2,
          isDiscount: true,
          name: "人工解析服务",
          price: "366",
          decimal: "00",
          desc: "协助完成域名解析的增、删、改的调整，每次调整10条以内。"
        },

        {
          path:
            "https://www.300.cn/domain/app-detail/domain-server-shimingrenzeng",
          iconPath: rgfw1,
          name: "人工实名制认证",
          price: "366",
          decimal: "00",
          desc: "协助您完成繁琐的域名实名制审核资料提交。"
        },
        {
          path:
            "https://www.300.cn/domain/app-detail/domain-server-yumingguohu",
          iconPath: rgfw4,
          name: "人工域名所有者变更",
          price: "366",
          decimal: "00",
          desc: "域名所有人过户业务，包含一次实名制认证人工代办服务。"
        },
        {
          path: "https://www.300.cn/domain/app-detail/domain-server-DNSxiugai",
          iconPath: rgfw3,
          name: "人工域名DNS修改",
          price: "366",
          decimal: "00",
          desc: "协助完成域名解析的增、删、改的调整，每次调整10条以内。"
        },
        {
          path: "https://www.300.cn/domain/app-detail/domain0007",
          iconPath: safetylock,
          name: "域名安全锁",
          price: "366",
          decimal: "00",
          desc: "有效的保护域名的注册信息和域名安全，避免恶意修改或错误修改。"
        },
        {
          path: "https://www.300.cn/domain/app-detail/domain-gaojiban-DNS",
          iconPath: seniordns,
          name: "高级版DNS",
          price: "366",
          decimal: "00",
          desc: "超大抗攻击服务机群，有效抵抗恶意DNS攻击，秒级识别及响应攻击。"
        }
      ],
      companyLinkList: [
        {
          iconPath: "",
          url: ""
        }
      ]
    }
  }
};
</script>

<style lang="scss">
@import "../../static/css/new-domain-content.scss";
</style>




// WEBPACK FOOTER //
// src/components/new-domain-content.vue